import { Paper, Typography, Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/fr";

dayjs.locale("fr");
interface CalendarCardProps {
  width?: number;
}

const CalendarCard = ({ width = 350 }: CalendarCardProps) => {
  return (
    <Paper elevation={3} sx={{ p: 2, borderRadius: 3, width }}>
      <Typography variant="subtitle2" gutterBottom>
        Calendrier
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
        <Box>
          <DateCalendar value={dayjs()} />
        </Box>
      </LocalizationProvider>
    </Paper>
  );
};

export default CalendarCard;
